

// 获取数量 fetchCount
import request from "@/utils/request";

export function fetchCount(query) {
  return request({
    url: "/crm/visit/getNumber",
    method: "get"
  });
}

export function selectPage(query) {
  return request({
    url: "/crm/visit/getList",
    method: "get",
    params: query
  });
}
  export function dealService(id, state) {
    const data = {
      id,
      state
    }
    return request({
      url: '/crm/visit/update',
      method: 'put',
      data: data
    })
}
// 删除投诉
export function delList(ids) {
  return request({
    url: "/crm/visit/deleteVisit/" + ids,
    method: "delete"
  });
}
// 获取订单集合
export function fetchAllOrderList(query) {
  return request({
    url: "/crm/visit/getOrder",
    method: "get",
    params: query
  });
}

// 获取联系人集合
export function fetchAllContactsList(query) {
  return request({
    url: "/crm/currency/getContactsListByCustomerIdNoPage",
    method: "get",
    params: query
  });
}
// 新增
export function addData(data) {
  return request({
    url: "/crm/visit/addVisit",
    method: "post",
    data: data
  });
}

// 修改
export function updateData(data) {
  return request({
    url: "/crm/visit/updateVisit",
    method: "put",
    data: data
  });
}
  // 根据id查询
  export function selectOne(query) {
    return request({
      url: "/crm/visit/getId",
      method: "get",
      params: query
    });
  }

